import { Route } from '@angular/router';

/** Dashboards, profile, SaaS admin, migration, sync. */
export const dashboardIntegrationsChildren: Route[] = [
  {
    path: 'sync-dashboard',
    loadComponent: () =>
      import('app/modules/platform/sync-dashboard/sync-dashboard.component').then(
        (m) => m.SyncDashboardComponent,
      ),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('app/modules/platform/dashboard/dashboard.module').then((m) => m.DashboardModule),
    data: { permission: 'other.dashboard.view' },
  },
  {
    path: 'saas-overview',
    loadComponent: () =>
      import('app/modules/platform/dashboard-saas/components/saas-overview/saas-overview.component').then(
        (m) => m.SaasOverviewComponent,
      ),
    data: { permission: 'other.dashboard.saas' },
  },
  {
    path: 'tenants/:id',
    loadComponent: () =>
      import('app/modules/platform/dashboard-saas/components/tenant-details/tenant-details.component').then(
        (m) => m.TenantDetailsComponent,
      ),
    data: { permission: 'other.details.tenant' },
  },
  {
    path: 'stores/:id',
    loadComponent: () =>
      import('app/modules/platform/dashboard-saas/components/store-details/store-details.component').then(
        (m) => m.StoreDetailsComponent,
      ),
    data: { permission: 'other.details.store' },
  },
  {
    path: 'user-profile',
    loadChildren: () =>
      import('app/modules/auth/user-profile/user-profile.routes').then((m) => m.default),
    data: { permission: 'other.profile.view' },
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('app/modules/platform/settings/pages/settings-page/settings-page.component').then(
        (m) => m.SettingsPageComponent,
      ),
    data: { permission: 'other.profile.settings' },
  },
  {
    path: 'mini-tenant-dashboard',
    loadComponent: () =>
      import('app/modules/platform/mini-tenant-dashboard/mini-tenant-dashboard.component').then(
        (m) => m.MiniTenantDashboardComponent,
      ),
  },
  {
    path: 'mini-dashboard',
    loadChildren: () =>
      import('app/modules/platform/mini-dashboard/mini-dashboard.module').then((m) => m.MiniDashboardModule),
  },
  {
    path: 'api-performance',
    loadChildren: () =>
      import('app/modules/platform/api-performance/api-performance.module').then(
        (m) => m.ApiPerformanceModule,
      ),
  },
  {
    path: 'migration-preview/data-preview',
    loadComponent: () =>
      import('app/modules/platform/migration-preview/pages/data-preview/data-preview.component').then(
        (m) => m.DataPreviewComponent,
      ),
  },
  {
    path: 'migration-preview',
    loadComponent: () =>
      import('app/modules/platform/migration-preview/pages/table-list/table-list.component').then(
        (m) => m.TableListComponent,
      ),
  },
  {
    path: 'migration-workflow',
    loadChildren: () =>
      import('app/modules/platform/migration-workflow/migration-workflow.routes').then(
        (m) => m.migrationWorkflowRoutes,
      ),
  },
];
